import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  FiltersState,
  FilterStateKeys,
  INew_TableAction,
  SetFilters
} from '@lla-platform/core/core-data-access'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Store } from '@ngxs/store'
import { ConfirmSimpleModeDialogComponent } from '../../../table-filter/components/confirm-simple-mode-dialog/confirm-simple-mode-dialog.component'
import { Observable } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'lla-overview-filters-header',
  templateUrl: './overview-filters-header.component.html',
  styleUrls: ['./overview-filters-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OverviewFiltersHeaderComponent implements OnInit, OnChanges {
  @Input() tableActions: INew_TableAction
  @Input() advancedFilterKey: FilterStateKeys
  @Output() clearAllFilters = new EventEmitter()

  isAdvancedMode: boolean

  numberOfAppliedFilters = 0

  constructor(
    private store: Store,
    private dialogService: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.advancedFilterKey) {
      const isAdvancedMode$: Observable<boolean> = this.store.select(
        (FiltersState as any)[this.advancedFilterKey]
      )

      isAdvancedMode$.pipe(untilDestroyed(this)).subscribe((res) => {
        this.isAdvancedMode = res
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableActions']?.currentValue) {
      const filters = this.tableActions?.filters ?? {}
      this.numberOfAppliedFilters = Object.values(filters).filter(
        (el) => el.items && el.items.length > 0
      ).length
    }
  }

  setAdvancedMode() {
    if (!this.advancedFilterKey) {
      return
    }
    if (this.isAdvancedMode) {
      this.dialogService
        .open(ConfirmSimpleModeDialogComponent, {
          autoFocus: false,
          panelClass: 'normal-modal'
        })
        .afterClosed()
        .pipe(untilDestroyed(this))
        .subscribe((res) => {
          if (res) {
            this.clearAllFilters.emit()
            this.store.dispatch(
              new SetFilters({
                [this.advancedFilterKey]: false
              })
            )
          }
        })
    } else {
      this.store.dispatch(
        new SetFilters({
          [this.advancedFilterKey]: true
        })
      )
    }
  }
}
